import { render, staticRenderFns } from "./EditRideType.vue?vue&type=template&id=10969208&"
import script from "./EditRideType.vue?vue&type=script&lang=js&"
export * from "./EditRideType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports